import { website } from '@/axios'

export default {
  // acceptMerchent (storeId, payload) {
  //   return marketPlace().patch(`admin/stores/${storeId}`, payload)
  // },
  getCategory (id) {
    return website().get(`admin/categories/${id}`)
  },
  addCategory (payload) {
    return website().post('admin/categories', payload)
  },
  editCategory (id, payload) {
    return website().put(`/admin/categories/${id}`, payload)
  },
  getCategories () {
    return website().get('admin/categories')
  },
  getNews (id) {
    return website().get(`/admin/news/${id}`)
  },
  editNews (id, payload) {
    return website().put(`/admin/news/${id}`, payload)
  },
  addNews (payload) {
    return website().post('admin/news', payload)
  },
  uploadImage (payload) {
    return website().post('upload', payload)
  }
}
